import { render, staticRenderFns } from "./CardGold.vue?vue&type=template&id=27002a38&scoped=true&"
import script from "./CardGold.vue?vue&type=script&lang=js&"
export * from "./CardGold.vue?vue&type=script&lang=js&"
import style0 from "./CardGold.vue?vue&type=style&index=0&id=27002a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27002a38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
